/* Subscribe & Save minimum quantity guard (assets/fec-sub-min-qty.js)
   Subscription bottle lines that drop below MIN_QTY are switched to one-time purchase, with a short notice
   shown at the top of the cart (One Click Upsell drawer, theme drawer or cart page). */
(function () {
  if (window.__fecSubMinQty) return;
  window.__fecSubMinQty = true;

  var MIN_QTY = 2;
  var VARIANT_MATCH = /bottle/i;
  var NOTICE = 'Subscribe & Save starts at 2 bottles, so we switched this item to a one-time purchase at full price.';
  var STORE_KEY = 'fecSubMinQtyNotice';
  var BOX_ID = 'fec-sub-min-qty-notice';
  var SHOW_MS = 30000;

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;

  var busy = false;
  var timer = null;
  var showUntil = 0;
  var mountObserver = null;

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function buildBox(floating) {
    var box = document.createElement('div');
    box.id = BOX_ID;
    box.setAttribute('role', 'status');
    box.style.cssText = floating
      ? 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,440px);margin:0;'
      : 'position:relative;margin:10px 12px;';
    box.style.cssText += 'padding:10px 36px 10px 12px;border-radius:8px;' +
      'background:#fff6e0;border:1px solid #f0c36d;color:#1c2430;font-size:13px;font-weight:600;line-height:1.4;' +
      'box-shadow:0 2px 8px rgba(0,0,0,.12);box-sizing:border-box;';
    var text = document.createElement('span');
    text.textContent = NOTICE;
    box.appendChild(text);
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss');
    close.textContent = '×';
    close.style.cssText = 'position:absolute;top:4px;right:8px;background:none;border:0;color:#1c2430;font-size:20px;line-height:1;cursor:pointer;';
    close.addEventListener('click', function () { showUntil = 0; box.remove(); });
    box.appendChild(close);
    return box;
  }

  function findHost() {
    var selectors = ['.ocu-cart-container', '#AjaxCartForm .cart__items', '#AjaxCartForm', 'form.cart__form', 'form[action$="/cart"]'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function mountInline() {
    if (Date.now() > showUntil) return false;
    if (document.getElementById(BOX_ID)) return true;
    var host = findHost();
    if (!host) return false;
    host.insertBefore(buildBox(false), host.firstChild);
    return true;
  }

  function showNotice() {
    try {
      var old = document.getElementById(BOX_ID);
      if (old) old.remove();
      showUntil = Date.now() + SHOW_MS;
      if (!mountInline()) {
        var toast = buildBox(true);
        document.body.appendChild(toast);
        window.setTimeout(function () { if (toast.parentNode) toast.remove(); }, 9000);
      }
      /* The drawer re-renders after a cart change; put the note back if it is wiped. */
      if (!mountObserver && window.MutationObserver) {
        mountObserver = new MutationObserver(function () {
          if (Date.now() < showUntil && !document.getElementById(BOX_ID)) mountInline();
        });
        mountObserver.observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  /* Skip Appstle fixed-bundle lines (Pack Your Expedition parents and their hidden
     child bottles), which Appstle manages. Volume-discount pack lines (the 2-pack /
     3-pack cards on the product page) are NOT skipped: they are what this guard protects. */
  function isBundleLine(it) {
    var props = it.properties || {};
    if (String(props['_appstle-bb-child']).toLowerCase() === 'true') return true;
    var type = props['_appstle_bundles_type'];
    return !!type && String(type).toUpperCase() !== 'VOLUME_DISCOUNT';
  }

  function enforce() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(function (it) {
          return it.selling_plan_allocation &&
            it.quantity < MIN_QTY &&
            VARIANT_MATCH.test(it.variant_title || '') &&
            !isBundleLine(it);
        });
        if (!bad.length) return false;

        var chain = Promise.resolve();
        bad.forEach(function (it) {
          chain = chain.then(function () {
            return origFetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: null })
            });
          });
        });
        return chain.then(function () { return true; });
      })
      .then(function (changed) {
        busy = false;
        if (!changed) return false;
        if (isCartPage()) {
          try { sessionStorage.setItem(STORE_KEY, '1'); } catch (e) {}
          window.location.reload();
        } else {
          if (typeof window.refreshCart === 'function') window.refreshCart(false);
          /* Tell the One Click Upsell drawer to redraw with the corrected cart. */
          try { window.dispatchEvent(new Event('ocu:cart:update')); } catch (e) {}
          showNotice();
        }
        return true;
      })
      .catch(function () { busy = false; return false; });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(enforce, 400);
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (!busy && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url)) {
      p.then(schedule, function () {});
    }
    return p;
  };

  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (/\/cart\/(change|update|add)(\.js)?(\?|$)/.test(String(url))) {
        this.addEventListener('loadend', function () { if (!busy) schedule(); });
      }
      return nativeOpen.apply(this, arguments);
    };
  }
  function ocuAction(e) {
    if (e.target && e.target.closest && e.target.closest('.ocu-cart-drawer')) {
      [700, 1800].forEach(function (d) { window.setTimeout(function () { if (!busy) enforce(); }, d); });
    }
  }
  document.addEventListener('click', ocuAction, true);
  document.addEventListener('change', ocuAction, true);

  function init() {
    try {
      if (sessionStorage.getItem(STORE_KEY)) {
        sessionStorage.removeItem(STORE_KEY);
        showNotice();
      }
    } catch (e) {}
    if (document.cookie.indexOf('cart=') !== -1) enforce();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
})();
